// Views
import UserList from '../../views/parazol/UserList';
import UserNew from '../../views/parazol/UserNew';
import UserForm from '../../views/parazol/UserForm';
import UserProfile from '../../views/parazol/UserProfile';
import UserActivate from '../../views/parazol/UserActivate';
import UserEmail from '../../views/parazol/UserEmail';
import ErrorFallback from '../../views/ErrorFallback';
// Components
import permissions from '../../permissions/permissionManagement';
import ProtectedRoute from '../ProtectedRoute';

/**
 *  @type {Route[]}
 */
export const parazolPrivateRoutes = [
  {
    path: '/users',
    element: (
      <ProtectedRoute permissions={permissions.users.accessUserListView}>
        <UserList />
      </ProtectedRoute>),
    errorElement: <ErrorFallback />,
  },
  {
    path: '/users/new',
    element: (
      <ProtectedRoute permissions={permissions.users.accessUserNewView}>
        <UserNew />
      </ProtectedRoute>
    ),
    errorElement: <ErrorFallback />,
  },
  {
    element: <ProtectedRoute><UserForm /></ProtectedRoute>,
    errorElement: <ErrorFallback />,
    children: [
      {
        path: '/user/:id/profile',
        element: (
          <ProtectedRoute permissions={permissions.users.updateUserProfile}>
            <UserProfile />
          </ProtectedRoute>
        ),
        errorElement: <ErrorFallback />,
      },
      {
        path: '/user/:id/activate',
        element: (
          <ProtectedRoute permissions={permissions.users.activateDeactivateUser}>
            <UserActivate />
          </ProtectedRoute>
        ),
        errorElement: <ErrorFallback />,
      },
      {
        path: '/user/:id/email',
        element: (
          <ProtectedRoute permissions={permissions.users.updateUserEmailAddress}>
            <UserEmail />
          </ProtectedRoute>
        ),
        errorElement: <ErrorFallback />,
      },
    ],
  },
];
